<template>
  <yv-form-search
    :formSearch="formSearch"
    :inlineSearchAction="true"
    :enableExport="false"
    @search="search"
    ref="formSearch"
  >
    <template #search-actions="{ actions }">
      <md-button
        native-type="submit"
        @click.native.prevent="actions.search"
        class="md-info md-round"
        >{{ $t("common.report") }}
      </md-button>
    </template>
  </yv-form-search>
</template>

<script>
import { getId, initLoader } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";
import YvFormSearch from "@/components/Base/YvFormSearch.vue";

const defaultTermOpt = {
  id: "",
  name: "All terms"
};

export default {
  components: { YvFormSearch },
  inject: ["fetchReport"],
  data() {
    return {
      formSearch: [
        {
          label: this.$t("common.term"),
          name: "term_id",
          value: "",
          type: "select",
          options: []
        },
        {
          label: this.$t("common.grade"),
          name: "grade_id",
          value: "",
          type: "select",
          options: [],
          trackBy: "id",
          displayField: "name"
        }
      ],
      selectedTerm: null,
      isInitView: true
    };
  },
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    search(queryParams) {
      const { term_id, grade_id } = queryParams;
      const searchingTerm = this.getSearchingTerm(term_id);
      const searchingGrade = this.getSearchingGrade(grade_id);

      this.fetchReport({
        searchingTerm,
        searchingGrade
      });
    },
    fetchTerms() {
      const queryParams = {
        limit: 200,
        order_by: "created_at ASC"
      };

      return this.$axios
        .get(
          service_paths.terms,
          queryParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data: resData }) => {
          const { data: terms } = resData;
          const formattedTerms = terms.map(term => ({
            id: getId(term),
            name: term.name
          }));
          this.formSearch[0].options = [defaultTermOpt, ...formattedTerms];
          this.formSearch[0].value = formattedTerms[0].id;
        });
    },
    fetchGrades() {
      return this.$axios
        .get(
          service_paths.grades,
          { limit: 20 },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(resp => {
          if (resp) {
            this.formSearch[1].options = resp.data?.data?.map(grade => ({
              id: getId(grade),
              name: grade.name
            }));
          }
        });
    },
    initialize() {
      const loader = initLoader();

      const setUpTermOpt = this.fetchTerms().then(() => {
        const defaultTermId = this.formSearch[0].value;
        this.$emit("set-searching-term", this.getSearchingTerm(defaultTermId));
      });
      const setUpGradeOpt = this.fetchGrades();

      Promise.all([setUpTermOpt, setUpGradeOpt]).finally(() => loader.hide());
    },

    getSearchingTerm(termId) {
      return this.formSearch[0].options.find(term => term.id === termId);
    },
    getSearchingGrade(gradeId) {
      if (!gradeId) return null;
      return this.formSearch[1].options.find(grade => grade.id === gradeId);
    }
  }
};
</script>

<style lang="scss" scoped></style>
